import {
  DraftCustomTemplateDocument,
  DraftCustomTemplateMutationVariables,
  DuplicateFormTemplateDocument,
  DuplicateFormTemplateMutationVariables,
  FormsCustomTemplatesDocument,
  PublishCustomTemplateDocument,
  PublishCustomTemplateMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDraftTemplate = () => {
  const [draftTemplate, { loading }] = useMutation(DraftCustomTemplateDocument, {
    extractorFn: (data) => data.formsMutations.draftTemplateFormsForm,
  })

  return {
    loading,
    draftFormTemplate(variables: DraftCustomTemplateMutationVariables) {
      return draftTemplate({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [FormsCustomTemplatesDocument],
      })
    },
  }
}

export const usePublishTemplate = () => {
  const [publishTemplate, { loading }] = useMutation(PublishCustomTemplateDocument, {
    extractorFn: (data) => data.formsMutations.publishTemplateFormsForm,
  })

  return {
    loading,
    publishFormTemplate(variables: PublishCustomTemplateMutationVariables) {
      return publishTemplate({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [FormsCustomTemplatesDocument],
      })
    },
  }
}

export const useDuplicateTemplate = () => {
  const [duplicateTemplate, { loading }] = useMutation(DuplicateFormTemplateDocument, {
    extractorFn: (data) => data.formsMutations.duplicateFormsForm,
  })

  return {
    loading,
    duplicateFormTemplate(variables: DuplicateFormTemplateMutationVariables) {
      return duplicateTemplate({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [FormsCustomTemplatesDocument],
      })
    },
  }
}
